module.exports = __webpack_public_path__ + "img/popup-bg.d8f60b4.png";